import { Box, Card, CardContent, FormControlLabel, Switch } from "@mui/material";
import React from "react";
import CardTitle from "./CardTitle";
import { useDispatch, useSelector } from "react-redux";
import { updateCalibrationSetting } from "../../reducer/CalcSettingsSlice";

export default function SurfaceCorrectionCard(props) {
    const calcSettings = useSelector(state => state.calcSettings);
    const dispatch = useDispatch();

    const handleCorrectChange = (property, value) => {
        dispatch(updateCalibrationSetting({property: property,value: value}));
    }

    return(
        <Box>
            <Card variant="outlined" >
                <CardContent >
                    <CardTitle title="Surface Correction" />
                    <FormControlLabel
                        control={
                            <Switch 
                                checked={calcSettings.changes.calibration.correctY} 
                                onChange={(evt) => {handleCorrectChange("correctY", evt.target.checked)}} 
                            />
                        }
                        label="Correct Y"
                    />
                    <FormControlLabel
                        control={
                            <Switch 
                                checked={calcSettings.changes.calibration.correctZ} 
                                onChange={(evt) => {handleCorrectChange("correctZ", evt.target.checked)}} 
                                
                            />
                        }
                        label="Correct Z"
                    />
                </CardContent>
            </Card>
        </Box>
    )
}